var map = {
	"./Automaton.png": "e050",
	"./College.png": "71b4",
	"./Countries.png": "300e",
	"./Profile.jpg": "4b4f",
	"./ReDesign.png": "7e7a",
	"./Skylight.png": "a69d",
	"./ToDo.png": "5615",
	"./VueGif.png": "7fc7",
	"./homeProfile.png": "8476",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";